import { Button, Carousel, Modal } from "antd";
import { useEffect, useRef, useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export const PostingCard = ({ open, record, onClose, onAction }) => {
  const postingCarouselRef = useRef(null);
  const [postingCarouselIndex, setPostingCarouselIndex] = useState(0);

  useEffect(() => {
    if (!open) return;

    setPostingCarouselIndex(0);
    postingCarouselRef.current?.goTo(0, true);
  }, [open, record?.confirm_url]);

  if (!open || !record?.confirm_url) return null;

  const urls =
    record.confirm_url
      .split(",")
      .map((url) => url.trim())
      .filter(Boolean) ?? [];
  const hasMultipleUrls = urls.length > 1;
  const isFirstIndex = postingCarouselIndex === 0;
  const isLastIndex = postingCarouselIndex === urls.length - 1;
  return (
    <Modal
      title={`${record.nickname}의 포스팅 확인`}
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
      className="overflow-y-auto"
    >
      <div className="w-full">
        <div className="mb-6 w-full">
          {urls.length > 0 && (
            <div className="flex w-full items-center gap-3">
              {hasMultipleUrls && (
                <Button
                  type="text"
                  shape="circle"
                  icon={<LeftOutlined />}
                  onClick={() => postingCarouselRef.current?.prev()}
                  className={
                    isFirstIndex ? "invisible pointer-events-none" : ""
                  }
                />
              )}
              <div className="min-w-0 flex-1">
                <Carousel
                  ref={postingCarouselRef}
                  dots={hasMultipleUrls}
                  infinite={false}
                  afterChange={setPostingCarouselIndex}
                >
                  {urls.map((url, index) => {
                    const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
                    const isVideo = /\.(mp4|webm|ogg|mov)$/i.test(url);

                    return (
                      <div key={`${url}-${index}`}>
                        <div>
                          <div className="flex h-[500px] items-center justify-center">
                            {isImage && (
                              <img
                                src={url}
                                alt={`원고 제출 이미지 ${index + 1}`}
                                className="max-h-full max-w-full object-contain rounded-lg border"
                              />
                            )}

                            {isVideo && (
                              <video
                                src={url}
                                controls
                                className="max-h-full max-w-full rounded-lg"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Carousel>
              </div>
              {hasMultipleUrls && (
                <Button
                  type="text"
                  shape="circle"
                  icon={<RightOutlined />}
                  onClick={() => postingCarouselRef.current?.next()}
                  className={isLastIndex ? "invisible pointer-events-none" : ""}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};
